<template>
  <div @touchmove.prevent>
    <div :class="$style.box">
      <div :class="$style.content">
        <div></div>
        <div></div>
        <div :class="$style.inner">
          <div :class="$style.top">{{ title }}</div>
          <div :class="$style.bot">
            <!-- 礼包码区域 -->
            <p>{{ `礼包码：${code}` }}</p>
            <!-- 中部礼包展示区域 -->
            <div :class="$style.show">
              <div v-for="(item, index) in config" :key="index">
                <img :src="giftConf[item.type]" alt="" />
                <p>{{ item.word }}</p>
              </div>
            </div>
            <!-- 底部按钮 -->
            <div :class="$style.btn">
              <img :src="`${$cdnUrl}/freeKingdoms/button_cancel.png`" @click="$emit('closeGift')" />
              <img
                class="copyBtn"
                :src="`${$cdnUrl}/freeKingdoms/button_copy.png`"
                @click="() => {}"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { giftConf } from './config';
import Clipboard from 'clipboard';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
    config: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      giftConf: giftConf,
    };
  },
  created() {
    this.copyInit();
  },
  methods: {
    copyInit() {
      // 礼包领取成功弹窗中点击复制
      this.copy = new Clipboard('.copyBtn', {
        text: () => {
          return this.code;
        },
      });
      this.copy.on('success', (e) => {
        this.$toast.success('复制成功');
      });
    },
  },
};
</script>

<style lang='scss' module>
.box {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10;
  overflow: hidden;
  .content {
    width: 300px;
    height: 372px;
    // background-color: pink;
    position: absolute;
    left: 50%;
    top: 120px;
    transform: translateX(-50%);
    > div:nth-child(1) {
      width: 282px;
      height: 100%;
      border: 1px solid #c2a67a;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    > div:nth-child(2) {
      width: 100%;
      height: 350px;
      border: 1px solid #c2a67a;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    .inner {
      width: 293px;
      height: 364px;
      border: 1px solid #c2a67a;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      background-color: #401f15;
      .top {
        width: 100%;
        height: 56px;
        background-color: #31170a;
        text-align: center;
        line-height: 56px;
        font-size: 23px;
        font-family: FZDaBiaoSong-B06S;
        font-weight: 400;
        color: #fff0b4;
      }
      .bot {
        width: 100%;
        height: 309px;
        position: relative;
        > p {
          width: 208px;
          height: 41px;
          background: #31100a;
          font-size: 17px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #eac15e;
          line-height: 41px;
          text-align: center;
          position: absolute;
          left: 50%;
          top: 28px;
          transform: translateX(-50%);
        }
        .show {
          width: 236px;
          height: 97px;
          position: absolute;
          left: 50%;
          top: 92px;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          > div {
            width: 74px;
            height: 100%;
            margin: 0px 4px;
            > img {
              width: 100%;
            }
            > p {
              width: 100%;
              font-size: 11px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #e8cf94;
              line-height: 14px;
              text-align: center;
              margin-top: 8px;
            }
          }
        }
        .btn {
          width: 100%;
          height: 32px;
          position: absolute;
          left: 50%;
          bottom: 38px;
          transform: translateX(-50%);
          display: flex;
          justify-content: space-between;
          padding: 0px 28px;
          > img {
            width: 111px;
          }
        }
      }
    }
  }
}
</style>